import React from 'react';
import './index.css';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import useEventTrackingLogEvent, { categories, eventSubTypes, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import { useBuildCommonFQEventProperties } from 'Views/FreemiumEntry/HasRelationship/Content/Components/utils';

export const SCHEDULE_MEETING_EQF_ACTION = 'schedule-meeting';

const EmbeddedSalesforceChatForEQF = ({
  resource,
}) => {
  const { logStandardizedEvent } = useEventTrackingLogEvent({ nodeName: 'eqfChat' });
  const { buildCommonFQEventProperties } = useBuildCommonFQEventProperties();

  // Existing Salesforce chat initialization logic
  function initESWForUpdatedChat() {
    window.embeddedservice_bootstrap.settings.language = 'en_US';

    window.addEventListener('onEmbeddedMessagingButtonCreated', () => {
      logStandardizedEvent(categories.facetQuiz, eventTypes.chat, eventSubTypes.impression, {
        eventProperties: {
          ...buildCommonFQEventProperties(resource),
          action: 'chat button created',
        },
      });
    });

    window.addEventListener('onEmbeddedMessagingConversationOpened', () => {
      logStandardizedEvent(categories.facetQuiz, eventTypes.chat, eventSubTypes.impression, {
        eventProperties: {
          ...buildCommonFQEventProperties(resource),
          action: 'conversation opened',
        },
      });
    });

    window.addEventListener('onEmbeddedMessagingConversationClosed', () => {
      logStandardizedEvent(categories.facetQuiz, eventTypes.chat, eventSubTypes.impression, {
        eventProperties: {
          ...buildCommonFQEventProperties(resource),
          action: 'conversation ended',
        },
      });
    });

    window.addEventListener('onEmbeddedMessagingConversationStarted', () => {
      logStandardizedEvent(categories.facetQuiz, eventTypes.chat, eventSubTypes.impression, {
        eventProperties: {
          ...buildCommonFQEventProperties(resource),
          action: 'conversation started',
        },
      });
    });

    window.addEventListener('onEmbeddedMessageSent', (msgEvent) => {
      logStandardizedEvent(categories.facetQuiz, eventTypes.chat, eventSubTypes.clickedCTA, {
        eventProperties: {
          ...buildCommonFQEventProperties(resource),
          action: 'message sent',
          isEndUser: msgEvent?.detail?.conversationEntry?.sender?.role === 'EndUser',
        },
      });
    });

    window.addEventListener('onEmbeddedMessagingWindowMinimized', () => {
      logStandardizedEvent(categories.facetQuiz, eventTypes.chat, eventSubTypes.clickedCTA, {
        eventProperties: {
          ...buildCommonFQEventProperties(resource),
          action: 'chat window minimized',
        },
      });
    });

    window.addEventListener('onEmbeddedMessagingWindowMaximized', () => {
      logStandardizedEvent(categories.facetQuiz, eventTypes.chat, eventSubTypes.clickedCTA, {
        eventProperties: {
          ...buildCommonFQEventProperties(resource),
          action: 'chat window maximized',
        },
      });
    });

    window.addEventListener('onEmbeddedMessageLinkClicked', () => {
      logStandardizedEvent(categories.facetQuiz, eventTypes.chat, eventSubTypes.clickLink, {
        eventProperties: {
          ...buildCommonFQEventProperties(resource),
          action: 'schedule meeting clicked',
        },
      });
    });


    window.addEventListener('onEmbeddedMessagingReady', () => {
      const fqSessionId = resource.attr('fqSessionIdForChat');
      const firstName = resource.attr('firstNameForChat');
      const lastName = resource.attr('lastNameForChat');
      const email = resource.attr('emailForChat');

      // build booking link
      const url = new URL(window.location.href);
      const params = url.searchParams;
      params.set('action', SCHEDULE_MEETING_EQF_ACTION);
      const bookingLink = url.toString();

      // Send data to Salesforce
      window.embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields({
        visitorSessionId: fqSessionId, firstName, lastName, email, bookingLink,
      });
    });

    window.embeddedservice_bootstrap.init(
      process.env.SF_ORG_ID,
      process.env.SF_CHAT_NAME_EQF_CHAT,
      process.env.SF_ORG_URL2_EQF_CHAT,
      { scrt2URL: process.env.SF_SCRT_URL },
    );
  }

  // eslint-disable-next-line consistent-return
  React.useEffect(() => {
    let s;
    if (!window.embeddedservice_bootstrap) {
      s = document.createElement('script');
      s.setAttribute('src', process.env.SF_CHAT_MIN_JS_URL_EQF_CHAT);
      // eslint-disable-next-line func-names
      s.onload = function () {
        initESWForUpdatedChat();
      };
      document.body.appendChild(s);
    } else {
      initESWForUpdatedChat();
    }

    if (s) {
      // eslint-disable-next-line consistent-return
      return () => {
        document.body.removeChild(s);
      };
    }
  }, [resource]);

  return null;
};

EmbeddedSalesforceChatForEQF.defaultProps = {
};

EmbeddedSalesforceChatForEQF.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};


export default EmbeddedSalesforceChatForEQF;
